import { supabase } from './supabase';

export const fetchOverviewData = async (landId, cropId) => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user || !landId || !cropId) return null;

  // سحب البيانات المفلترة فقط للأرض والزرعة الحالية
  const [expenses, income, labor, spray, chemicals, irrigation, machines, maintenance] = await Promise.all([
    supabase.from('expenses').select('*').eq('land_id', landId).eq('crop_id', cropId),
    supabase.from('income').select('*').eq('land_id', landId).eq('crop_id', cropId),
    supabase.from('labor').select('*').eq('land_id', landId).eq('crop_id', cropId),
    supabase.from('spray_cycles').select('*').eq('land_id', landId).eq('crop_id', cropId),
    supabase.from('chemicals').select('*').eq('land_id', landId).eq('crop_id', cropId),
    supabase.from('irrigation').select('*').eq('land_id', landId).eq('crop_id', cropId),
    supabase.from('machines').select('*').eq('land_id', landId).eq('crop_id', cropId),
    supabase.from('maintenance').select('*').eq('land_id', landId).eq('crop_id', cropId)
  ]);

  // تجهيز النشاطات المفلترة
  const allActivities = [
    ...(expenses.data || []).map(i => ({ ...i, type: 'expense', title: i.description, amount: i.amount, category: i.category })),
    ...(income.data || []).map(i => ({ ...i, type: 'income', title: i.source, amount: i.amount, category: 'دخل' })),
    ...(labor.data || []).map(i => ({ ...i, type: 'labor', title: `يومية: ${i.worker_name}`, amount: i.amount, category: 'عمالة' })),
    ...(spray.data || []).map(i => ({ ...i, type: 'spray', title: i.name, amount: i.total_cost, category: 'رش' })),
    ...(chemicals.data || []).map(i => ({ ...i, type: 'chemical', title: i.name, amount: i.cost, category: 'كيماويات' })),
    ...(irrigation.data || []).map(i => ({ ...i, type: 'irrigation', title: `ري ${i.method || ''}`, amount: i.cost || 0, category: 'ري' })),
    ...(machines.data || []).map(i => ({ ...i, type: 'machines', title: `آلة: ${i.machine_name}`, amount: (Number(i.rental_cost) || 0) + (Number(i.operation_cost) || 0), category: 'آلات' })),
    ...(maintenance.data || []).map(i => ({ ...i, type: 'maintenance', title: `صيانة: ${i.machine_name}`, amount: i.maintenance_cost, category: 'صيانة' }))
  ].sort((a, b) => new Date(b.date || b.created_at) - new Date(a.date || a.created_at));

  // حساب الإجماليات بدقة
  const totalLabor = labor.data?.reduce((sum, i) => sum + Number(i.amount || 0), 0) || 0;
  const totalSpray = spray.data?.reduce((sum, i) => sum + Number(i.total_cost || 0), 0) || 0;
  const totalChem = chemicals.data?.reduce((sum, i) => sum + Number(i.cost || 0), 0) || 0;
  const totalIrrigation = irrigation.data?.reduce((sum, i) => sum + Number(i.cost || 0), 0) || 0;
  const totalMachines = machines.data?.reduce((sum, i) => sum + (Number(i.rental_cost || 0) + Number(i.operation_cost || 0)), 0) || 0;
  const totalMaintenance = maintenance.data?.reduce((sum, i) => sum + Number(i.maintenance_cost || 0), 0) || 0;
  const totalOtherExp = expenses.data?.reduce((sum, i) => sum + Number(i.amount || 0), 0) || 0;

  const totalExp = totalLabor + totalSpray + totalChem + totalIrrigation + totalMachines + totalMaintenance + totalOtherExp;
  const totalInc = income.data?.reduce((sum, i) => sum + Number(i.amount || 0), 0) || 0;

  return {
    stats: {
      totalExpenses: totalExp,
      totalIncome: totalInc,
      profit: totalInc - totalExp,
      laborCount: labor.data?.length || 0,
      sprayCount: spray.data?.length || 0
    },
    breakdown: {
      labor: totalLabor,
      chemicals: totalChem,
      spray: totalSpray,
      irrigation: totalIrrigation,
      machines: totalMachines,
      maintenance: totalMaintenance,
      other: totalOtherExp
    },
    activities: allActivities
  };
};